"use client";
import React from "react";
import FilterPatientScript from "../../../global/view/filter-patient-scriptForm";

export default function FullPatientScriptList() {
  return (
    <FilterPatientScript
      hideNewScriptButton={false}
      hideMedicationHistoryButton={false}
      columnsToHide={[]}
      hideOtc={true}
    />
  );
}
